/**
 * Module Federation：入口必须异步加载，否则 standalone 会触发
 * Shared module is not available for eager consumption 导致白屏。
 */
import('./bootstrap');
